import {
	LoginResponse,
	LoginRequest,
	LogoutRequest,
	CardLoginRequest,
	FingerprintLoginRequest,
	UnregisterNotificationTokenRequest
} from 'core/api';

import { Bus, SessionProvider, Events } from 'core/infrastructure';
import { Cordova } from 'pos/common';
import * as SettingsProvider from './SettingsProvider';
const process = Bus.buildProcessFn('/bus/');

async function getNotificationToken(): Promise<string> {
	try {
		return await Cordova.getNotificationToken();
	} catch {
		return '';
	}
}

export async function unregisterNotificationToken() {
	const request = new UnregisterNotificationTokenRequest({ notificationToken: await getNotificationToken() });
	return process(request);
}

const handleLoginResponse = async (response: LoginResponse) => {

	const ok = response.Success;

	if (ok) {
		await SessionProvider.setCurrent(response.Session);
		await Events.raise('session:login', response.Session);
	}
	return { ok, errorMessage: response.ErrorMessage };
};

export async function login(userName: string, password: string): Promise<{ ok: boolean, errorMessage: string }> {

	const settings = SettingsProvider.load();

	const request = new LoginRequest({
		userName: userName,
		userPassword: password,
		defaultLanguageCode: settings.languageCode,
		restorePreviousSession: false,
		rememberMe: false,
		notificationToken: await getNotificationToken()
	});

	return process(request, handleLoginResponse);
}

export async function loginByCardNumber(cardNumber: string): Promise<{ ok: boolean, errorMessage: string }> {

	const settings = SettingsProvider.load();
	const request = new CardLoginRequest({
		defaultLanguageCode: settings.languageCode,
		cardNumber
	});
	return process(request, handleLoginResponse);
}

export async function loginByUserId(userId: number): Promise<{ ok: boolean; errorMessage: string; }> {
	const settings = SettingsProvider.load();
	const request = new FingerprintLoginRequest({
		defaultLanguageCode: settings.languageCode,
		userId
	});
	return process(request, handleLoginResponse);
}

export async function logout(): Promise<void> {
	const request = new LogoutRequest({ notificationToken: await getNotificationToken() });
	await process<LogoutRequest>(request);

	await SessionProvider.clearCurrent();
	await Events.raise('session:logout');
}
